import { useParams } from 'react-router-dom'

import { usePortfolioNewsDetailQuery } from 'src/app/home/repositories/use-portfolio-news-detail-query'
import { usePortfolioNewsQuery } from 'src/app/home/repositories/use-portfolio-news-query'

import type { IPortfolioNewsArticleEntity } from '../types'

export interface IUsePortfolioNewsDetailReturn {
  article: IPortfolioNewsArticleEntity | undefined
  relatedArticles: IPortfolioNewsArticleEntity[]
  isLoading: boolean
}

const RELATED_NEWS_COUNT = 3

export const usePortfolioNewsDetail = (): IUsePortfolioNewsDetailReturn => {
  const { articleId } = useParams<{ articleId: string }>()
  const { data: article, isLoading: isArticleLoading } =
    usePortfolioNewsDetailQuery(articleId)

  const { data: recentNewsData } = usePortfolioNewsQuery({
    page: 1,
    pageSize: RELATED_NEWS_COUNT + 1,
    search: '',
    company: '',
    enabled: true,
    silentErrorToast: true,
  })

  const relatedArticles: IPortfolioNewsArticleEntity[] = (
    recentNewsData?.items ?? []
  )
    .filter(item => item.id !== articleId)
    .slice(0, RELATED_NEWS_COUNT)

  return {
    article,
    relatedArticles,
    // Related news is supplemental: it must not hide an available article.
    isLoading: isArticleLoading,
  }
}
